module.exports = __webpack_public_path__ + "img/form-mail.edf0049f.svg";